<template>
  <div class="AskForLeave">
    <div class="Tit">教师事项</div>
    <div class="tab">
      <li @click="tabClick(index)" :class="index === tabsIndex ? 'choice':'' " v-for="(item,index) in tabs"
          :key="index">
        {{item}} <span></span>
      </li>
    </div>

    <div v-if=" tabsIndex === 0 " class="qingjia">
      <div class="top">
        <div class="int">
          <div class="t fl">请假原因：</div>
          <div class="content fl">
            <el-input v-model="describe" placeholder="请输入内容"></el-input>
          </div>
        </div>
        <div class="int">
          <div class="t fl">请假时间：</div>
          <div class="block fl">
            <el-date-picker
              v-model="time"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期"
              :picker-options="pickerOptions"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </div>
      </div>
      <div @click="sure" class="sure">确认</div>
      <div style="margin-top: 10px;" class="Tit">教师记录</div>
      <div class="lilu">
        <div class="li">
          <div class="y">请假原因</div>
          <div class="s">开始时间</div>
          <div class="e">结束时间</div>
          <div class="z">请假状态</div>
        </div>
        <li class="li" v-for="(item,index) in info.data" :key="index">
          <div class="y">{{item.describe}}</div>
          <div class="s">{{item.start_time}}</div>
          <div class="e">{{item.end_time}}</div>
          <div class="z">
            <span class="r" v-if="item.state === 1">通过</span>
            <span class="h" v-if="item.state === 2">未通过</span>
            <span v-if="item.state === 3">待审核</span>
          </div>
        </li>
      </div>
      <div style="clear: both;"></div>
      <div class="page">
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="pageChange"
          :total="info.count">
        </el-pagination>
      </div>
    </div>

    <div v-if=" tabsIndex === 1 " class="shixiang">
      <textarea v-model="content"></textarea>

      <div @click="addmatter" class="sure">确认</div>
    </div>

    <div v-if=" tabsIndex === 2 " class="agreement">
      <div v-html="agreementHtml.data" class="html"></div>
      <div @click="addout" class="sure">确认</div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        describe: '',
        time: [],
        page: 1,
        tabs: ['教师请假', '事项申请', '退出申请'],
        tabsIndex: 0,
        info: {},
        content: '',
        agreementHtml: '',
        pickerOptions: {
          disabledDate (time) {
            return time.getTime() < Date.now() - 8.64e7
          }
        }
      }
    },
    created () {
      this.getList()
    },
    methods: {
      tabClick (index) {
        this.tabsIndex = index
      },
      pageChange (page) {
        this.page = page
        this.getList()
      },
      addout () {
        this.$confirm('确认退出？')
          .then(_ => {
            this.$http.post('/apipx/Teacher/addout', {
              token: JSON.parse(localStorage.getItem('login')).token
            }).then(res => {
              if (res.code === 0) {
                this.$message({
                  message: '退出成功',
                  type: 'success',
                  duration: 2000
                })
              }
            })
          })
      },
      addmatter () {
        if (this.content === '') {
          this.$message({
            message: '请输入申请内容',
            type: 'error',
            duration: 2000
          })
          return false
        }
        this.$http.post('/apipx/Teacher/addmatter', {
          content: this.content,
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.$message({
              message: '申请成功',
              type: 'success',
              duration: 2000
            })
          }
        })
      },
      sure () {
        if (this.describe === '') {
          this.$message({
            message: '请输入请假原因',
            type: 'error',
            duration: 2000
          })
          return false
        }
        if (this.time.length === 0) {
          this.$message({
            message: '请选择请假时间',
            type: 'error',
            duration: 2000
          })
          return false
        }
        this.$http.post('/apipx/Teacher/addleave', {
          describe: this.describe,
          start_time: this.time[0],
          end_time: this.time[1],
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.$message({
              message: '申请成功',
              type: 'success',
              duration: 2000
            })
            this.getList()
          }
        })
      },
      getList () {
        this.$http.post('/apipx/Personal/leaverecord', {
          p: this.page,
          row: 10,
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.info = res
          }
        })
        this.$http.post('/apipx/Teacher/getouttreaty', {
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.agreementHtml = res
          }
        })
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .AskForLeave {

    .shixiang textarea {
      width: 600px;
      height: 200px;
      border: 1px solid #d9d9d9;
      border-radius: 20px;
      padding: 15px;
      line-height: 40px;
      font-size: 14px;
    }

    .Tit {
      width: 890px;
      height: 69px;
      line-height: 69px;
      font-size: 24px;
      border-bottom: 1px solid #ebebeb;
      font-weight: bold;
    }

    .tab {
      width: 890px;
      height: 130px;
      line-height: 130px;

      li {
        width: 120px;
        height: 130px;
        position: relative;
        float: left;
        cursor: pointer;

        span {
          display: block;
          width: 20px;
          height: 3px;
          background-color: #fff;
          position: absolute;
          left: 13%;
          top: 80px;
        }

        &.choice {
          color: #ff8484;

          span {
            background-color: #ff8484;
          }
        }

        &:nth-child(4n-1) {
          &.choice {
            span {
              left: 20%;
            }
          }
        }

        &:nth-child(4n) {
          &.choice {
            span {
              left: 30%;
            }
          }
        }
      }
    }

    .top {

      .int {
        margin: 20px 0 0 0;
        overflow: hidden;

        .t {
          width: 80px;
          text-align: right;
          font-size: 16px;
          height: 42px;
          line-height: 42px;
        }

        .block {
          border: 1px solid #c6c6c6;
          margin: 0 0 0 20px;
          border-radius: 5px;
        }

        .el-input__inner {
          border: 0;
        }

        .content {
          width: 300px;
          height: 40px;
          border: 1px solid #c6c6c6;
          margin: 0 0 0 20px;
          border-radius: 5px;

          .el-input__inner {
            border: 0;
            width: 300px;
          }
        }
      }
    }

    .sure {
      height: 40px;
      line-height: 40px;
      text-align: center;
      width: 300px;
      border-radius: 5px;
      color: #fff;
      font-size: 14px;
      background-color: #ff8484;
      margin: 50px 0 0 100px;
      cursor: pointer;
    }

    .lilu {
      .li {
        height: 50px;
        line-height: 50px;
        border-bottom: 1px solid #ebebeb;
        display: flex;

        .y {
          flex: 1;
          display: inline-block;
        }

        .s {
          flex: 1;
          display: inline-block;
          text-align: center;
        }

        .e {
          flex: 1;
          display: inline-block;
          text-align: center;
        }

        .z {
          flex: 1;
          display: inline-block;
          text-align: right;

          .r {
            color: #ff8484;
          }

          .h {
            color: #c6c6c6;
          }

        }

        &:first-child {
          border: 0;
        }
      }
    }

    .page {
      height: 35px;
      margin: 50px auto 0;

      .el-pagination {
        width: 500px;
        margin: 0 auto;
      }

      .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
        border-radius: 50%;
        min-width: 33px;
        min-height: 33px;
        line-height: 33px;
        margin: 0 8px;

        &:hover {
          color: #ff8484;
        }
      }

      .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #ff8484;
        color: #FFF;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/userInfo/AskForLeave/AskForLeave.vue